var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "term-of-service-modal",
        title: _vm.$t("message.privacyPolicyAndTerms"),
        okText: "I read and agree",
        cancelText: _vm.$t("message.cancel"),
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: function ($event) {
          return _vm.$emit("agree")
        },
      },
    },
    [
      _c(
        "a-tabs",
        { attrs: { "default-active-key": _vm.type } },
        [
          _c(
            "a-tab-pane",
            { key: "pp", attrs: { tab: _vm.$t("message.privacyPolicyTab") } },
            [
              _c("div", { staticClass: "term-of-service-modal-content" }, [
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.privacyPolicyTitle"))),
                  ]),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyDescription"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.informationWeCollect"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("message.weCollectFollowingInformation"))
                  ),
                ]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.customerAccountInformation"))),
                ]),
                _vm._v(": " + _vm._s(_vm.$t("message.customerAccountData"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.userInformation")))]),
                _vm._v(
                  ": " + _vm._s(_vm.$t("message.userProvidedInformation"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.dataDeletionProcess"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.dataDeletionProcedures"))),
                ]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.automaticDeletion")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.automaticDeletionInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.directRequest")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.directRequestInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.websiteVisitorDataDeletion"))),
                ]),
                _vm._v(
                  ": " +
                    _vm._s(_vm.$t("message.websiteVisitorDataDeletionInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [_vm._v(_vm._s(_vm.$t("message.howToContactUs")))]),
                ]),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.contactChannels")))]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n\n                Email: m@softcand.com WhatsApp: +902162322282 Website: supsis.com or softcand.com Live Support on\n                Website: supsis.com or softcand.com"
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.dataProcessingAndSharing"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.handleCustomerData")))]),
                _vm._v(":"),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.noThirdPartySharing"))),
                ]),
                _vm._v(
                  ": " + _vm._s(_vm.$t("message.noThirdPartySharingInfo"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.promotionalEmails")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.promotionalEmailsInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.visitorAndConversationData"))),
                ]),
                _vm._v(": " + _vm._s(_vm.$t("message.noSharingVisitorData"))),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.thirdPartyServices"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("h5", [
                  _c("b", [_vm._v(_vm._s(_vm.$t("message.googleOAuth")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("message.googleCalendar")))]),
                _vm._v(": " + _vm._s(_vm.$t("message.googleCalendarInfo"))),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.googleAccountPublicProfile"))),
                ]),
                _vm._v(
                  ": " +
                    _vm._s(_vm.$t("message.googleAccountPublicProfileInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_c("b", [_vm._v("YouTube API Services")])]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                Our application uses YouTube API Services to access and display YouTube data, including channel information,\n                video metadata, and comments. By using this application, you acknowledge and agree that your use of YouTube\n                data is also subject to the\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.google.com/policies/privacy",
                      target: "_blank",
                    },
                  },
                  [_vm._v("Google Privacy Policy")]
                ),
                _vm._v(".\n                "),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Data We Access via YouTube API:")]),
                _vm._v(
                  " We may access and store authorized YouTube data such as channel\n                information, video metadata, video statistics, and comments on behalf of the authorizing user."
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Cookies and Tracking:")]),
                _vm._v(
                  " This application stores, accesses, and collects information directly or\n                indirectly on or from users' devices, including by placing, accessing, or recognizing cookies or similar\n                technology on users' devices or browsers for authentication and session management purposes."
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Data Retention:")]),
                _vm._v(
                  " YouTube API data is refreshed regularly and automatically deleted after 30 calendar\n                days in accordance with YouTube API Services Developer Policies. Authorization tokens are stored only as\n                long as the user's consent remains active."
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Data Deletion:")]),
                _vm._v(
                  " Users can request deletion of their stored YouTube data at any time. Upon request,\n                all stored data will be deleted within 7 calendar days."
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_c("b", [_vm._v("Revoking Access")])]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                In addition to this application's normal procedure for deleting stored data, users can revoke this\n                application's access to their data via the Google security settings page at\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://myaccount.google.com/connections",
                      target: "_blank",
                    },
                  },
                  [_vm._v("https://myaccount.google.com/connections")]
                ),
                _vm._v(
                  ".\n                Upon revocation, all authorized data accessed or stored pursuant to that consent will be deleted within\n                30 calendar days.\n                "
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.changesToPrivacyPolicy"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyUpdateInfo"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.privacyPolicyContactInfo")) +
                    "\n            "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "tac",
              attrs: {
                tab: _vm.$t("message.termsAndConditionsTab"),
                "force-render": "",
              },
            },
            [
              _c("div", { staticClass: "term-of-service-modal-content" }, [
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.termsOfServiceTitle"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.lastUpdated")) +
                    " 27 Haziran 2023. " +
                    _vm._s(_vm.$t("message.inEffect")) +
                    " 1 Temmuz 2023. " +
                    _vm._s(_vm.$t("message.importantTerms"))
                ),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.termsDescription"))
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("1 " + _vm._s(_vm.$t("message.applicationOfTerms"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsApplyToAllUsers")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsUpdateNotice")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.termsDisagreementNotice")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.consumerRightsNotice")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("2 " + _vm._s(_vm.$t("message.theService")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceGrant")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAccess")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAgentAppointment")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.additionalAccountsAppointment")
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.accountControl")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceAffiliation")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceLinks")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentMonitoring")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.serviceControl")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "3 " + _vm._s(_vm.$t("message.yourRightsAndObligations"))
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentAdditionRestriction")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.restrictionsOnServiceUse")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("4 " + _vm._s(_vm.$t("message.payments")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.paymentAcknowledgment"))),
                ]),
                _vm._v(":\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.paymentMethodDebit")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.cancellationPolicy")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("5 " + _vm._s(_vm.$t("message.intellectualProperty"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.contentDefinition")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("message.intellectualPropertyRightsTransfer")
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.userContentRights")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.grantLicense")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.subLicense")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.moralRights")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.licenseSurvival")) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.rightsRepresentation")) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("6 " + _vm._s(_vm.$t("message.warranties")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.$t("message.warrantiesAcknowledgment"))),
                ]),
                _vm._v(":\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.accountOwnership"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.serviceUsageAgreement"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.legalCapacity")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("7 " + _vm._s(_vm.$t("message.liability")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.liabilityForLoss"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.indemnification")))]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.exclusionOfLiability"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.totalLiabilityLimit"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.exclusionOfTerms"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.statutoryObligations"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.statuteProhibition"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v("8 " + _vm._s(_vm.$t("message.termination"))),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationAutomatic"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationNotice"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.cancelService")))]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.terminationRights"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("9 " + _vm._s(_vm.$t("message.general")))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.assignmentRestriction"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.invalidProvision"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.expenseResponsibility"))),
                  ]),
                  _vm._v(" "),
                  _c("li", [_vm._v(_vm._s(_vm.$t("message.governingLaw")))]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("10 Third-Party Services")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("b", [_vm._v("YouTube API Services:")]),
                    _vm._v(
                      " By using this application, you also agree to be bound by the\n                        "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.youtube.com/t/terms",
                          target: "_blank",
                        },
                      },
                      [_vm._v("YouTube Terms of Service")]
                    ),
                    _vm._v(".\n                    "),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }